import Repository from "./Repository";
import _ from "lodash";

const getPath = (path) => {
  return `shipment/${path}`;
};

class ShipmentRepository extends Repository {
  checkPromoCode = async (params) => {
    try {
      const data = await this.postData(getPath(`check-promocode`), params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onGetAdditionalShippingChargers = async () => {
      try {
          const data = await this.getData(getPath('additional-shipment-charges'), {});
          return _.get(data, `data`);
      } catch (error) {
          return { error };
      }
  };

  submitShipmentRequest = async (params) => {
    try {
      const data = await this.postData(getPath('submit-request'), params);
      return _.get(data, `data`);
  } catch (error) {
      return { error };
  }
  }

  getShipmentQueue = async () =>{
    try {
      const data = await this.getData('order/shipped-queue', {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  }

  getTrackingDetails = async (params) =>{
    try {
      const data = await this.postData('order/tracking', params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  }
}

export default new ShipmentRepository("Shipment");
